import React, {memo} from 'react'
import { AwardsNextButton } from '../../styles/awardsStyles'
import { NextArrow } from '../../assets/svg/icons'

const SliderButton = ({ handleNext }) => {
  return (
    <AwardsNextButton onClick={() => handleNext()} aria-label='Siguiente'>
      <div>
        <NextArrow />
      </div>
    </AwardsNextButton>
  )
}

export default memo(SliderButton)
